import React from 'react';
import { Popover, Button, Select, Icon, Checkbox } from 'antd';

const { Option } = Select;

export const ImageStatus = ({ onChange, statuses, params }) => {
  const changeSort = () => {
    let order;

    if (params?.order === '') {
      order = 'asc';
    } else if (params?.order === 'asc') {
      order = 'desc';
    } else {
      order = '';
    }

    onChange({ ...params, order });
  };

  const content = (
    <>
      <div style={{ marginBottom: 8 }} onClick={changeSort}>
        <b style={{ marginRight: 5 }}>Sort:</b>
        {!params?.order && <Icon type='column-height' />}
        {params?.order === 'asc' && <Icon type='sort-ascending' />}
        {params?.order === 'desc' && <Icon type='sort-descending' />}
      </div>
      <div style={{ masrginBottom: 8 }}>
        <Checkbox
          onChange={(e) => {
            if (e.target.checked) {
              onChange({ ...params, value: statuses });
            } else {
              onChange({ ...params, value: [] });
            }
          }}
          checked={statuses.every((status) =>
            (params?.value || []).includes(status)
          )}
        >
          All
        </Checkbox>
      </div>

      <Select
        value={params?.value}
        mode='multiple'
        style={{ width: 140, marginRight: '10px' }}
        allowClear
        placeholder='Image status'
        onChange={(value) => {
          onChange({ ...params, value });
        }}
      >
        {statuses.map((status) => (
          <Option key={status} value={status}>
            {status}
          </Option>
        ))}
      </Select>
    </>
  );

  return (
    <Popover content={content} title='Image status' trigger='click'>
      <Button className='sighting-filter' style={{ width: '14%' }}>
        Image status
        <Icon type='down' style={{ color: '#d9d9d9' }} />
      </Button>
    </Popover>
  );
};
